/**
 * aufgaben-format — reine Hilfsfunktionen für die Aufgaben-Darstellung.
 * Bewusst ohne React/Supabase, damit sie isoliert per Vitest testbar sind.
 */

export const AUFGABEN_STATUS_LABEL: Record<string, string> = {
  offen: 'Offen',
  in_bearbeitung: 'In Bearbeitung',
  erledigt: 'Erledigt',
  abgebrochen: 'Abgebrochen',
};

export const AUFGABEN_PRIO_LABEL: Record<string, string> = {
  niedrig: 'Niedrig',
  mittel: 'Mittel',
  hoch: 'Hoch',
  dringend: 'Dringend',
};

export function statusLabel(s: string | null | undefined): string {
  return (s && AUFGABEN_STATUS_LABEL[s]) || 'Offen';
}

export function prioLabel(p: string | null | undefined): string {
  return (p && AUFGABEN_PRIO_LABEL[p]) || 'Mittel';
}

/** Akzeptiert reine DATE-Strings (YYYY-MM-DD) sowie volle ISO-Timestamps. */
function parseTag(s: string): Date {
  return new Date(s.length <= 10 ? `${s}T00:00:00` : s);
}

/** true, wenn die Aufgabe noch offen/in Bearbeitung ist und die Frist vor heute liegt. */
export function istUeberfaellig(
  faelligAm: string | null | undefined,
  status: string | null | undefined,
  heute: Date = new Date(),
): boolean {
  if (!faelligAm) return false;
  if (status === 'erledigt' || status === 'abgebrochen') return false;
  const d = parseTag(faelligAm);
  if (isNaN(d.getTime())) return false;
  const heuteTag = new Date(heute.getFullYear(), heute.getMonth(), heute.getDate());
  return d.getTime() < heuteTag.getTime();
}

export function initialen(vorname?: string | null, nachname?: string | null): string {
  const v = (vorname || '').trim();
  const n = (nachname || '').trim();
  const ini = `${v[0] || ''}${n[0] || ''}`.toUpperCase();
  return ini || '?';
}

export function formatFrist(faelligAm: string | null | undefined): string {
  if (!faelligAm) return 'Keine Frist';
  const d = parseTag(faelligAm);
  if (isNaN(d.getTime())) return 'Keine Frist';
  return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
}
